<template>
  <div id="app">
    <header_menu v-if="!isMobile"></header_menu>
    <headerMenuPhone v-if="isMobile"></headerMenuPhone>
    <router-view/>
  </div>
</template>
<script>
import header_menu from "@/components/header_menu";
import headerMenuPhone from "@/components/header_menu_phone";
import { isMobileUA } from '@/utils/ua'
export default {
  components:{
    header_menu,
    headerMenuPhone
  },
  data(){
    return{
      isMobile: false,
    }
  },
  created(){
    // 与 nginx 的 map $ytx_is_mobile 同一套判断（见 src/utils/ua.js 说明）
    this.isMobile = isMobileUA()
  }
}
</script>

<style lang="scss">
body {
  margin: 0;
  min-width: 1330px;
}
</style>
